export default __webpack_public_path__ + "static/media/bg.9c811a51.jpg";